import {themeBreakpoints} from "./constants";

(function () {
    'use strict';


    document.querySelectorAll('.swiper-donateurs-carousel').forEach((container) => {
        new Swiper(container, {
            direction: 'horizontal',
            autoplay: {
                delay: 2000,
            },
            speed: 1000,
            loop: true,
            loopPreventsSliding: false,
            pagination: false,
            navigation: true,
            scrollbar: false,
            slidesPerView: 2,
            breakpoints: {
                [themeBreakpoints.lg]: {
                    slidesPerView: 4,
                },
                [themeBreakpoints.xl]: {
                    slidesPerView: 6,
                }
            }
        });
    });

    document.querySelectorAll('.swiper-testimonials-carousel').forEach((container) => {
        new Swiper(container, {
            direction: 'horizontal',
            autoplay: {
                delay: 2000,
            },
            speed: 1000,
            loop: true,
            loopPreventsSliding: false,
            navigation: false,
            scrollbar: false,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            slidesPerView: 1,
            breakpoints: {
                [themeBreakpoints.md]: {
                    slidesPerView: 2,
                    //spaceBetween: 32,
                },

                [themeBreakpoints.xl]: {
                    slidesPerView: 3,
                    //spaceBetween: 32,
                }
            }
        });
    });

})();


function idz_bak() {

    document.querySelectorAll('.swiper-donateurs-carousel').forEach((parent) => {

        const container = parent.querySelector('.swiper');

        if (!container) {
            return;
        }

        const swiper = new Swiper(container, {
            direction: 'horizontal',
            speed: 1000,
            loop: true,
            pagination: false,
            scrollbar: false,
        });


        /** @type { HTMLElement | null } previousButton  **/
        const previousButton = parent.querySelector('.swiper-button-prev');

        /** @type { HTMLElement | null } previousButton  **/
        const nextButton = parent.querySelector('.swiper-button-next');

        if (previousButton) {
            previousButton.setAttribute('aria-controls', swiper.wrapperEl.getAttribute('id'));
            previousButton.addEventListener('click', () => swiper.slidePrev());
        }

        if (nextButton) {
            nextButton.setAttribute('aria-controls', swiper.wrapperEl.getAttribute('id'));
            nextButton.addEventListener('click', () => swiper.slideNext());
        }

    });


    /**
     *   new Swiper('.carousel', {
     *             // Optional parameters
     *             direction: 'horizontal',
     *             autoplay: {
     *                 delay: 2000,
     *             },
     *             speed: 1000,
     *             loop: true,
     *         });
     */

    /*new Swiper('.products-carousel', {
        // Optional parameters
        direction: 'horizontal',
        autoplay: {
            delay: 5000,
        },
        speed: 1000,
        loop: true,

        // Navigation arrows
        navigation: {
            // nextEl: '.swiper-button-next',
            //prevEl: '.swiper-button-prev',
        },
    });*/


}